import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { getProject, fetchProject, fetchProposalList, getProposalList, 
  cancelProject, updateProject, selectProposal, submitProject, deleteProject } from '../../../store/client'

import TableData from '../../../shared/ui/TableData'
import { capitalize, secondsToTime } from '../../../shared/utilities/helpers'
import InfoSection from '../../../shared/ui/InfoSection'
import Section from '../../../shared/ui/Section'
import Text from '../../../shared/ui/Text'
import StatusTracker from '../../../shared/ui/StatusTracker'
import DialogBox from '../../../shared/ui/DialogBox'
import DateCard from '../../../shared/ui/DateCard'
import DetailViewController from '../../../shared/ui/DetailViewController'
import Button from '../../../shared/ui/Button'
import { NavigationContext } from '../../../shared/ui/NavigationController'
import Link from '../../../shared/ui/Link'
import { formatValue } from '../../../shared/ui/TableData'
import StatusLabel from '../../../shared/ui/StatusLabel'

import ProjectFormView from '../views/ProjectFormView'
import CourseCard from '../views/CourseCard'

import { withStyles } from '@material-ui/core/styles'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import BackIcon from '@material-ui/icons/ArrowBackIos'
import GroupIcon from '@material-ui/icons/Group'
import OrderSubmitForm from '../views/OrderSubmitForm'
import ProposalSelectForm from '../views/ProposalSelectForm'
import CancelOrderForm from '../views/CancelOrderForm'

const styles = theme => ({
  root: {
  },
  iconLabel: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(0.5)
  }
})

const OrderDetailController = ({ theme, classes, ...props }) => {
  const { orderKey, isFetching, lastFetched, data, onEdit, cancelProject, 
    updateProject, deleteProject, submitProject, fetchProposalList, proposal, selectProposal, fetchProject } = props
  
  const navigationContext = useContext(NavigationContext)
  const [editForm, setEditForm] = useState(onEdit || false)
  const [formData, setFormData] = useState({})
  const [openDialog, setOpenDialog] = useState(false)
  
  const [openReason, setOpenReason] = React.useState(false);
  const [orderedProposal, setOrderedProposal] = React.useState(null);
  const [submitOrder, setSubmitOrder] = React.useState(false);
  
  useEffect(() => {
    fetchProject(true)
    fetchProposalList()
  }, [])  

  const handleCancelProject = (value) => {
    cancelProject(value, () => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog({title:'Cool!', description:'Order has been canceled!'})
      setOpenReason(false)
    })
  }

  const ProviderStatusColor = {
    'Invited': '#ffaa00',
    'Pending Proposal': '#0000cc',
    'Pending Revision': '#0000cc',
    'Proposal Submitted': '#00aa00',
    'Selected': '#000000',
    'Canceled': '#aaaaaa',
  }

  const actionButtons = [
    <Button color='primary' size='large' id='acceptProposal' 
      onClick={ () => setOpenDialog(true) }>Edit</Button>
  ]

  const submitFormOrder = () => {
    navigationContext.showLoadingDialog(true)
    submitProject({}, () => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog({title:'Cool!', description:'Order has been submitted!'})
      setSubmitOrder(false)
    })
  }

  if(lastFetched && !data.submitted_at){
    actionButtons.push(
      <Button variant="contained" id='acceptProposal' 
        onClick={ () =>  setSubmitOrder(true) }
        >
        Submit Request
      </Button>
    )
  }

  const columns = [
    { key: 'logo_url', label: '', type: 'image', aspectRatio: 1.5, width: '6em' }, 
    { key: 'name', label:'Name', variant: 'title'},
    { key: 'proposal_no', label: 'Proposal', wordWrap: false },
    { key: 'line_items', label: '' },
    { key: 'total', label: 'Total Price', type: 'currency'},
    { key: 'status', label: 'Status', wordWrap: false}
  ]

  const proposalList = proposal.lastFetched ? proposal.data.records.filter(item => item.submitted_at) : []

  const getCellValue = (row, column, rowIndex, columnIndex) => {
    let matchedProposal = proposalList.filter(item => item.provider.uid === row.uid)
    if (column.key == 'proposal_no') {
      return matchedProposal.length > 0 ? matchedProposal[0].proposal_no : 'Waiting for Proposal'
    }
    else if (column.key == 'line_items') {
      if (matchedProposal.length > 0) {
        return (
          <Box>          
              <ul style={{ marginTop: 0, marginBottom: 0 }}>
              { matchedProposal[0].training_classes && matchedProposal[0].training_classes.map(items =>
                <li>
                  <Box>
                    <Typography variant='body1'>
                      <b>{items.course ? items.course.name : ''} {items.trainer ? "by "+items.trainer.first_name + ' ' + items.trainer.last_name : ''}</b>
                    </Typography>
                    <Typography variant='body1'>
                      {moment(items.training_date).format('DD MMM YYYY')}, {items.participant_count} pax
                    </Typography>
                    { items.delivery_method !== 'offline' ?
                      <Typography variant='body1'>
                        {capitalize(items.delivery_method) || 'Online'} Class {items.delivery_method !== 'offline' ? 'via '+(items.delivery_app || 'Zoom') : ''}
                      </Typography>
                    :
                    <Box>
                      <Typography variant='body1'>
                        {capitalize(items.delivery_method) || 'Online'} Class
                      </Typography>
                      {  items.venue &&
                      <>
                        <Typography variant='body1'>
                          Location : {items.venue ? items.venue.state : ''} - {items.venue ? items.venue.line4 : ''}
                        </Typography>
                        <Typography variant='body1'>
                          Venue : {items.venue ? (items.venue.in_house ? 'In House' : 'Arranged by PasarTrainer') : ''}
                        </Typography>
                      </>
                      }
                    </Box>
                    }
                    <Box display='flex'>
                      <Box>
                        <Link to={'/company/order/view/' + orderKey + '/proposal/' + matchedProposal[0].uid}>
                          <Button>
                            View Proposal
                          </Button>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                </li>
              )}
              </ul>
          </Box>
        )
      }
      else{
        return ''
      }
    } else if (column.key === 'total') {
      return matchedProposal.length > 0 ? matchedProposal[0].total : 0
    } else if (column.key === 'status') {
      return (
        <StatusLabel color={ProviderStatusColor[row.provider_status] || '#555'}>
          { row.provider_status }
          </StatusLabel>
      )
    } else if (column.key === 'action') {
      if (matchedProposal.length > 0 && matchedProposal[0].submitted_at && !matchedProposal[0].selected_at && !matchedProposal[0].canceled_at && !matchedProposal[0].revise_requested_at){
        return (
          <Box>
            <Button variant='contained' onClick={() => setOrderedProposal(matchedProposal[0].uid)}>
              Order
            </Button>
          </Box>
        )
      } else {
        return ''
      }
    }
  
    return row[column.key]
  }

  if (lastFetched && data.status === 'Proposal Received') {
    columns.push({ key: 'action', label: 'Action'})
  }

  const getCellSecondaryValue = (row, column) => {
    // if (column.key == 'line_items')
    //     return moment(row.training_date).format('DD MMM YYYY') + ', ' + row.participant_count +' pax'
  }
  
  const backButton = (
    <Button icon={BackIcon} onClick={() => navigationContext.openLink("/company/order")}>
      Order List
    </Button>
  )

  const getCourseDetailLink = (row) => {
      return `/course/${row.uid}`
  }

  const handleSelectProposal = () => {
    selectProposal(orderedProposal, () => {
      navigationContext.showLoadingDialog(false)
      navigationContext.showMessageDialog(true)
      navigationContext.setMessageDialog(
        {
          title:'Cool!', 
          description:'You have completed the order process! Now your class is ready to deliver. The training provider and us will ensure everything is ready for the training day.'
        }
      )
      navigationContext.openLink("/company/order")
      setOrderedProposal(null)
    })
  }

  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }
    
    setFormData(newFormData)
  }

  const showDetailProposal = (row) => {
    let matchedProposal = proposalList.filter(item => item.provider.uid === row.uid)
    if(matchedProposal.length > 0){
      navigationContext.openLink(`/company/order/view/${orderKey}/proposal/${matchedProposal[0].uid}`)
    }else{
      alert(`${row.name} has not submitted any proposal`)
    }
  }
  
  let title = lastFetched && (
    data.course ? data.course.name : `${data.title} (Custom Course)`
  )

  let infoItems = []
  if (lastFetched) {
    infoItems.push({ label: 'Project No', value: data.project_no || '-' })
    
    if (data.delivery_method == 'online') {
      infoItems.push({ label: 'Delivery Type', value: `Online via ${data.delivery_app || 'Zoom'}` })
    }
    else {
      infoItems.push({ label: 'Delivery Type', value: 
        <>
          Offline
          { data.venue &&
            <>
              <Typography>
                Location: { data.venue.state } - { data.venue.line4 }
              </Typography>
              <Typography>
                Venue:  { data.venue.in_house ? 'In House' : 'Arranged By PasarTrainer' }
              </Typography>
            </>              
          }
        </>

      })
    }
    
    infoItems.push({ label: 'Date', value:
      <Box display='flex'>
        {data.schedules && data.schedules.length > 0 && data.schedules.map(item => 
          <DateCard item={ item.training_date }/>
        )}
        {data.schedules && data.schedules.length <= 0 &&
          <DateCard item={ data.training_date }/>
        }
      </Box>
    })

    infoItems.push({ label: 'Pax', value:
      <> 
        <Box display='flex' alignItems='center'>
            <GroupIcon className={classes.iconLabel} style={{ color: 'black' }}/>
            <Typography variant='body2'>
              {data.participant_count + ' pax'}
            </Typography>
        </Box>
      </>
    })
    
    // infoItems.push({ label: 'Pax', value: data.participant_count })

    if (!data.course) {
      infoItems.push({ label: 'Category', value: data.category ? data.category.name : '-' }) 
    }   
  }

  let selectedProposal = proposalList.filter(item => !item.canceled_at && item.selected_at)
  
  let activeStatus = 0
  if (lastFetched && data.status === 'Canceled') {
    activeStatus = -1
  } else if (lastFetched && data.status === 'Draft') {
    activeStatus = 0
  } else if (lastFetched && data.status === 'Ready to Invite') {
    activeStatus = 1
  } else if (lastFetched && data.status === 'Waiting for Training Providers') {
    activeStatus = 2
  } else if (lastFetched && data.status === 'Invite Sent') {
    activeStatus = 2
  } else if (lastFetched && data.status === 'Waiting for Proposal') {
    activeStatus = 3
  } else if (lastFetched && data.status === 'Waiting for Revision') {
    activeStatus = 3
  } else if (lastFetched && selectedProposal.length === 0) {
    activeStatus = 4
  } else if (lastFetched && selectedProposal.length > 0) {
    activeStatus = 5
  } else {
    activeStatus = 0
  }
  
  let requirements = null
  if (lastFetched && !data.course && data.description && data.description.startsWith('{'))
    requirements = JSON.parse(data.description)
  
  return (
    <DetailViewController
      title={title}
      isFetching={isFetching}
      lastFetched={lastFetched}
      backButton={backButton}
      actionButtons={lastFetched && !data.accepted_at && !data.canceled_at && selectedProposal.length === 0 ? actionButtons : 
        (
        lastFetched && data.canceled_at ?
          [<Box mt={2} display='flex' flexDirection='column' justifyContent='center' alignItems="center">
              <CancelOutlinedIcon style={{color:'red', fontSize: 30}}/>
              <Typography variant='body1' style={{fontWeight:'bold'}}>Canceled</Typography>
          </Box>] 
          : 
          []
        )}  
      >
        { lastFetched &&
        <>
          <Box mt={2} />
          
          <StatusTracker
          listStatus={['Submit Request', 'Invite Provider', 'Wait for Response', 'Wait for Proposal', 'Place Order']}
          activeStatus={activeStatus}
          />
          
          <InfoSection gutterBottom
            items={infoItems}
            />

          { data.course ?       
            <Section title="Course" gutterBottom>
              <Section variant='subsection' gutterBottom>
                <Box width='50%'>
                  <CourseCard 
                    theme={theme} classes={classes}
                    item={data.course}
                    linkTo={getCourseDetailLink(data.course)}
                    variant='horizontal'
                    target={'_blank'}
                  />
                </Box>
              </Section>
            </Section>
          :
          <>
            <Section title="Course Detail" gutterBottom>
              { requirements ?
                <>
                  <Section title="Objectives" variant='subsection' gutterBottom>
                    <Text text={requirements.objectives} format='markdown' />
                  </Section>          
                  <Section title="Audience" variant='subsection' gutterBottom>
                    <Text text={requirements.audience} format='markdown' />
                  </Section>    
                </>
              :
                <Text text={data.description} format='markdown' />                
              }
            </Section>            
            
           </>
          }
          
          { data.notes &&
            <Section title='Additional Requests' gutterBottom>
              <Text text={data.notes} format='markdown' />
            </Section>
          }        

          <Section title='Training Providers' gutterBottom>
            { data.providers && data.providers.length > 0 ?
              <TableData
                columns={columns}
                rows={lastFetched ? data.providers : []}
                getCellValue={getCellValue}
                getCellSecondaryValue={getCellSecondaryValue}
                // onRowClick={(row) => showDetailProposal(row)}
              />
            :
              <Typography>
                Invite training providers to receive proposal for this project.
              </Typography>
            }
            
            { !data.canceled_at && data.submitted_at && !data.course && selectedProposal.length === 0 &&
              <Box mt={2}>
                <Section title="Invite" variant="subsection">
                  <Button color='primary' size='large' variant='contained' onClick={ () => navigationContext.openLink('/company/order/view/'+orderKey+'/invite') }>Invite Training Providers</Button>
                </Section>
              </Box>
            }
          
          </Section>

          { data.order &&
            <Section title='Order Detail' gutterBottom>
              <Section title="Order No." variant="subsection">
                <Typography variant='body1'>
                  {data.order.order_no || '-'}
                </Typography>
              </Section>
              <Section title="Date Issued" variant="subsection">
                <Typography variant='body1'>
                  {moment(data.order.order_date).format('DD MMM YYYY') || '-'}
                </Typography>
              </Section>
              <Section title="Payment Term" variant="subsection">
                <Typography variant='body1'>
                  {data.order.payment_term || '-'}
                </Typography>
              </Section>
              <Section title="Total" variant="subsection">
                <Typography variant='body1'>
                  {formatValue(data.order.total_incl_tax, 'currency') || '-'}
                </Typography>
              </Section>
              <Section title="Paid Amount" variant="subsection">
                <Typography variant='body1'>
                  {formatValue(data.order.total_incl_tax, 'currency') || '-'}
                </Typography>
              </Section>
            </Section>
          }

          { !data.order && !data.canceled_at &&
          <Section title='More' gutterBottom>    
            {data.submitted_at ?      
            <Button
              color='disabled'
              onClick={ () => setOpenReason(true) }>
              Cancel Order
            </Button>
            :
            <Button
              color='disabled'
              onClick={ () => {
                if (window.confirm('Are you sure?'))
                  navigationContext.showLoadingDialog(true)
                  deleteProject(() => {
                    navigationContext.showLoadingDialog(false)
                    navigationContext.showMessageDialog(true)
                    navigationContext.setMessageDialog({title:'Cool!', description:'Order has been deleted!'})
                    navigationContext.openLink("/company/order")
                  })
              } }>
              Delete Order
            </Button>
            }
          </Section>          
          }
        </>
        }


      {openReason &&
        <CancelOrderForm onClose={ () => setOpenReason(false)} onConfirm={handleCancelProject}/>
      }

      { orderedProposal &&
        <ProposalSelectForm onClose={() => setOrderedProposal(null)} onConfirm={handleSelectProposal} />
      }

      { submitOrder && 
        <OrderSubmitForm onClose={() => setSubmitOrder(false)} onConfirm={submitFormOrder} />
      }

      { lastFetched &&
      <ProjectFormView 
        showDialog={openDialog} 
        isEdit={true} 
        onSave={updateProject} 
        course={data.course ? data.course : null} 
        isCustom={!data.course ? true : false} 
        initialData={ lastFetched ? data : {}} 
        onClose={() => setOpenDialog(false)}
        type={ data.course ? 'private' : 'custom' }
      />
    }

    </DetailViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  let orderKey = ownProps.match.params.orderKey
    
  return {
    orderKey,
    ...getProject(state, orderKey),
    proposal: getProposalList(state, orderKey)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let orderKey = ownProps.match.params.orderKey
  return {
    fetchProject: (refresh) => {
      dispatch(fetchProject(orderKey, true))
    },
    fetchProposalList: () => {
      dispatch(fetchProposalList(orderKey, true))
    },
    updateProject: (data, onComplete) => {
      dispatch(updateProject(orderKey, data, onComplete))
    },
    cancelProject: (data, onComplete) => {
      dispatch(cancelProject(orderKey, data, onComplete))
    },
    submitProject: (data, onComplete) => {
      dispatch(submitProject(orderKey, data, onComplete))
    },
    deleteProject: (onComplete) => {
      dispatch(deleteProject(orderKey, onComplete))
    },
    selectProposal: (proposalKey, onComplete) => {
      dispatch(selectProposal(orderKey, proposalKey, onComplete))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(OrderDetailController)
)
